module.exports = __webpack_public_path__ + "static/media/select-seta.e9d1b74f.svg";